import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-center align-center py-8"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "font-weight-medium" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "font-weight-medium" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "d-flex align-center justify-space-between mb-4" }
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "text-body-1 text-medium-emphasis" }
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = { class: "redemption-content" }
const _hoisted_14 = { class: "d-flex align-center mb-1" }
const _hoisted_15 = { class: "text-body-2 text-medium-emphasis ml-2 font-weight-medium" }
const _hoisted_16 = { class: "d-flex align-center mb-1" }
const _hoisted_17 = { class: "text-body-2 text-medium-emphasis ml-2" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_19 = { class: "text-body-2 text-medium-emphasis ml-2" }
const _hoisted_20 = {
  key: 1,
  class: "d-flex align-center",
  style: {"height":"20px"}
}
const _hoisted_21 = { class: "redemption-actions" }
const _hoisted_22 = {
  key: 3,
  class: "text-center pa-12"
}

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import AdminLayout from './components/AdminLayout.vue'
import { useAuthStore } from './stores/authStore'

interface Redemption {
  id: string
  userId: string
  itemId: string
  itemName: string
  points: number
  timestamp: number
  workspaceId: string
  claimed?: boolean
  claimedAt?: number
  updating?: boolean
  userHandle: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminRedemptions',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const redemptions = ref<Redemption[]>([])
const showSuccess = ref(false)
const showError = ref(false)
const successMessage = ref('')
const errorMessage = ref('')
const statusFilter = ref('all')

const filterOptions = [
  { title: 'All Redemptions', value: 'all' },
  { title: 'Awaiting Claim', value: 'pending' },
  { title: 'Claimed', value: 'claimed' }
]

const filteredRedemptions = computed(() => {
  if (statusFilter.value === 'all') {
    return redemptions.value
  } else if (statusFilter.value === 'pending') {
    return redemptions.value.filter(r => !r.claimed)
  } else if (statusFilter.value === 'claimed') {
    return redemptions.value.filter(r => r.claimed)
  }
  return redemptions.value
})

const formatDate = (timestamp: number): string => {
  return new Date(timestamp).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const fetchRedemptions = async () => {
  loading.value = true
  showError.value = false
  
  try {
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/admin/redemptions`, {
      credentials: 'include'
    })
    
    if (!response.ok) {
      throw new Error('Failed to fetch redemptions')
    }
    
    const data = await response.json()
    console.log('Fetched redemptions data:', data)
    
    redemptions.value = data.map((redemption: any) => {
      console.log('Processing redemption:', redemption)
      return {
        ...redemption,
        updating: false
      }
    })
    
    console.log('Processed redemptions:', redemptions.value)
  } catch (error) {
    console.error('Error fetching redemptions:', error)
    errorMessage.value = 'Failed to load redemptions'
    showError.value = true
  } finally {
    loading.value = false
  }
}

const markAsClaimed = async (redemption: Redemption) => {
  redemption.updating = true
  
  try {
    console.log('Marking redemption as claimed:', redemption.id)
    
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/admin/redemptions/${redemption.id}/claim`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        claimed: true,
        claimedAt: Date.now()
      })
    })
    
    console.log('Response status:', response.status)
    console.log('Response ok:', response.ok)
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      console.error('Error response data:', errorData)
      throw new Error(`Failed to mark redemption as claimed: ${response.status} ${response.statusText}`)
    }
    
    // Update local state
    redemption.claimed = true
    redemption.claimedAt = Date.now()
    
    successMessage.value = `Redemption "${redemption.itemName}" for @${redemption.userHandle} marked as claimed`
    showSuccess.value = true
    
    // Hide success message after 3 seconds
    setTimeout(() => {
      showSuccess.value = false
    }, 3000)
    
  } catch (error: any) {
    console.error('Error marking redemption as claimed:', error)
    errorMessage.value = error.message || 'Failed to mark redemption as claimed'
    showError.value = true
  } finally {
    redemption.updating = false
  }
}

const viewDetails = (redemption: Redemption) => {
  // For now, just show an alert with details
  // In the future, this could open a detailed modal
  alert(`Redemption Details:\n\nItem: ${redemption.itemName}\nUser: @${redemption.userHandle || 'Unknown User'}\nPoints: ${redemption.points}\nRedeemed: ${formatDate(redemption.timestamp)}\nClaimed: ${formatDate(redemption.claimedAt || 0)}`)
}

const { checkAuth } = useAuthStore()

onMounted(async () => {
  try {
    // Check if user is admin using auth store
    const authData = await checkAuth()
    if (!authData.isAdmin) {
      router.push('/dashboard')
      return
    }

    await fetchRedemptions()
  } catch (error) {
    console.error('Error loading admin redemptions:', error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "3",
            class: "rounded-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between pa-6 bg-gradient-primary" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-gift-outline",
                      class: "mr-3",
                      size: "32",
                      color: "white"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-h5 font-weight-bold text-white" }, "Redemptions Management", -1))
                  ]),
                  _createVNode(_component_v_btn, {
                    color: "white",
                    variant: "elevated",
                    "prepend-icon": "mdi-refresh",
                    size: "large",
                    class: "px-6",
                    onClick: fetchRedemptions,
                    loading: loading.value
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Refresh ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "pa-6" }, {
                default: _withCtx(() => [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          color: "primary",
                          size: "64",
                          width: "6"
                        }),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ml-4 text-h6 text-medium-emphasis" }, "Loading redemptions...", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (showSuccess.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "success",
                              class: "mb-6",
                              closable: "",
                              variant: "tonal",
                              border: "start",
                              "border-color": "success"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-check-circle",
                                  color: "success"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(successMessage.value), 1),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    variant: "text",
                                    size: "small",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false))
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (showError.value)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 1,
                              type: "error",
                              class: "mb-6",
                              closable: "",
                              variant: "tonal",
                              border: "start",
                              "border-color": "error"
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-alert-circle",
                                  color: "error"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(errorMessage.value), 1),
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_btn, {
                                    icon: "mdi-close",
                                    variant: "text",
                                    size: "small",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
                                  })
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (redemptions.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_v_icon, {
                                            icon: "mdi-information",
                                            color: "info",
                                            class: "mr-2"
                                          }),
                                          _createElementVNode("span", _hoisted_11, _toDisplayString(filteredRedemptions.value.length) + " of " + _toDisplayString(redemptions.value.length) + " redemption" + _toDisplayString(redemptions.value.length !== 1 ? 's' : '') + " found ", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_v_select, {
                                            modelValue: statusFilter.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((statusFilter).value = $event)),
                                            items: filterOptions,
                                            label: "Filter by status",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            class: "filter-dropdown",
                                            style: {"min-width":"200px"}
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list, { class: "redemptions-list" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRedemptions.value, (redemption) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: redemption.id,
                                      class: _normalizeClass(["redemption-item", { 'claimed': redemption.claimed }])
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_avatar, {
                                          color: redemption.claimed ? 'success' : 'warning',
                                          size: "48",
                                          class: "mr-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: redemption.claimed ? 'mdi-check-circle' : 'mdi-clock',
                                              size: "24",
                                              color: "white"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])
                                      ]),
                                      append: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(_component_v_chip, {
                                            color: "primary",
                                            variant: "flat",
                                            size: "small",
                                            class: "mr-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: "mdi-currency-usd",
                                                class: "mr-1"
                                              }),
                                              _createTextVNode(" " + _toDisplayString(redemption.points) + " Tokens ", 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_chip, {
                                            color: redemption.claimed ? 'success' : 'warning',
                                            variant: "flat",
                                            size: "small",
                                            class: "mr-3"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, {
                                                icon: redemption.claimed ? 'mdi-check-circle' : 'mdi-clock',
                                                class: "mr-1"
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" " + _toDisplayString(redemption.claimed ? 'Completed' : 'Awaiting Claim'), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["color"]),
                                          (!redemption.claimed)
                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                color: "success",
                                                variant: "elevated",
                                                size: "default",
                                                "prepend-icon": "mdi-check",
                                                onClick: ($event: any) => (markAsClaimed(redemption)),
                                                loading: redemption.updating,
                                                class: "mr-2"
                                              }, {
                                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                  _createTextVNode(" Mark as Claimed ", -1)
                                                ]))]),
                                                _: 2
                                              }, 1032, ["onClick", "loading"]))
                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                key: 1,
                                                color: "info",
                                                variant: "outlined",
                                                size: "default",
                                                "prepend-icon": "mdi-eye",
                                                onClick: ($event: any) => (viewDetails(redemption))
                                              }, {
                                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                  _createTextVNode(" View Details ", -1)
                                                ]))]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createVNode(_component_v_list_item_title, { class: "text-h6 font-weight-bold mb-2" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(redemption.itemName), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_list_item_subtitle, { class: "mb-0" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_14, [
                                                _createVNode(_component_v_icon, {
                                                  icon: "mdi-account",
                                                  color: "primary",
                                                  class: "mr-2",
                                                  size: "16"
                                                }),
                                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-body-2 font-weight-medium" }, "User:", -1)),
                                                _createElementVNode("span", _hoisted_15, " @" + _toDisplayString(redemption.userHandle || 'Unknown User'), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_16, [
                                                _createVNode(_component_v_icon, {
                                                  icon: "mdi-calendar",
                                                  color: "primary",
                                                  class: "mr-2",
                                                  size: "16"
                                                }),
                                                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-body-2 font-weight-medium" }, "Redeemed:", -1)),
                                                _createElementVNode("span", _hoisted_17, _toDisplayString(formatDate(redemption.timestamp)), 1)
                                              ]),
                                              (redemption.claimed)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                    _createVNode(_component_v_icon, {
                                                      icon: "mdi-check",
                                                      color: "success",
                                                      class: "mr-2",
                                                      size: "16"
                                                    }),
                                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-body-2 font-weight-medium" }, "Claimed:", -1)),
                                                    _createElementVNode("span", _hoisted_19, _toDisplayString(formatDate(redemption.claimedAt || 0)), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (!redemption.claimed)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[9] || (_cache[9] = [
                                                    _createElementVNode("span", { class: "text-body-2 text-transparent" }, "Claimed:", -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-gift-off",
                                size: "80",
                                color: "grey-lighten-1",
                                class: "mb-4"
                              }),
                              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-h5 text-grey-darken-1 mb-2" }, "No Redemptions Found", -1)),
                              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-body-1 text-medium-emphasis mb-6" }, " When users redeem rewards, they will appear here for you to manage ", -1))
                            ]))
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})